(function(){
  if(window._mmLb) return;
  window._mmLb = true;

  // ââ CSS ââââââââââââââââââââââââââââââââââââââââââââââââââââââââââââââââââââââ
  var style = document.createElement('style');
  style.textContent =
    /* suppress native Shopify modal */
    'product-modal{display:none!important;visibility:hidden!important;pointer-events:none!important;}' +

    /* root overlay */
    '#mm-lb{display:none!important;position:fixed!important;inset:0!important;z-index:99999!important;' +
      'background:rgba(0,0,0,0.70)!important;align-items:center!important;justify-content:center!important;}' +
    '#mm-lb.open{display:flex!important;}' +

    /* white modal */
    '.mm-lb-modal{position:relative!important;background:#fff!important;border-radius:10px!important;' +
      'box-shadow:0 30px 90px rgba(0,0,0,0.45)!important;width:90vw!important;max-width:820px!important;' +
      'max-height:92vh!important;display:flex!important;flex-direction:column!important;overflow:hidden!important;}' +

    /* close button */
    '.mm-lb-x{position:absolute!important;top:12px!important;right:14px!important;width:30px!important;' +
      'height:30px!important;background:transparent!important;border:none!important;' +
      'color:#666!important;font-size:20px!important;line-height:1!important;' +
      'cursor:pointer!important;display:flex!important;align-items:center!important;' +
      'justify-content:center!important;z-index:3!important;padding:0!important;}' +
    '.mm-lb-x:hover{color:#000!important;}' +

    /* stage: image area â overflow hidden clips zoomed image */
    '.mm-lb-stage{position:relative!important;display:flex!important;align-items:center!important;' +
      'justify-content:center!important;overflow:hidden!important;flex:1!important;min-height:0!important;}' +

    /* main image â cursor WITHOUT !important so JS setProperty can override it */
    '.mm-lb-img{max-width:100%!important;max-height:calc(92vh - 200px)!important;' +
      'object-fit:contain!important;display:block!important;' +
      'transition:opacity .18s!important;' +
      'cursor:zoom-in;}' +
    '.mm-lb-img.loading{opacity:0.15!important;}' +

    /* nav arrows */
    '.mm-lb-arr{position:absolute!important;top:50%!important;transform:translateY(-50%)!important;' +
      'width:42px!important;height:42px!important;border-radius:50%!important;' +
      'background:#fff!important;border:1px solid #e0e0e0!important;' +
      'color:#444!important;cursor:pointer!important;display:flex!important;' +
      'align-items:center!important;justify-content:center!important;z-index:2!important;' +
      'box-shadow:0 2px 8px rgba(0,0,0,0.12)!important;padding:0!important;' +
      'transition:box-shadow .15s!important;}' +
    '#mm-lb-prev{left:12px!important;}' +
    '#mm-lb-next{right:12px!important;}' +
    '.mm-lb-arr:hover{box-shadow:0 4px 16px rgba(0,0,0,0.18)!important;}' +

    /* counter */
    '.mm-lb-info{font-size:12px!important;color:#888!important;' +
      'font-family:-apple-system,sans-serif!important;letter-spacing:.05em!important;' +
      'position:absolute!important;bottom:15px!important;left:20px!important;}' +

    /* zoom buttons */
    '.mm-lb-zoom{position:absolute!important;bottom:11px!important;right:16px!important;' +
      'display:flex!important;gap:6px!important;}' +
    '.mm-lb-zb{width:28px!important;height:28px!important;border-radius:50%!important;' +
      'background:#fff!important;border:1px solid #ddd!important;' +
      'color:#555!important;font-size:16px!important;line-height:1!important;' +
      'cursor:pointer!important;display:flex!important;align-items:center!important;' +
      'justify-content:center!important;padding:0!important;}' +
    '.mm-lb-zb:hover{background:#f5f5f5!important;}' +

    /* thumbnail strip */
    '.mm-lb-thumbs{display:flex!important;gap:6px!important;overflow-x:auto!important;' +
      'padding:10px 14px!important;border-top:1px solid #f0f0f0!important;' +
      'scrollbar-width:thin!important;scrollbar-color:#ddd transparent!important;}' +
    '.mm-lb-th{width:52px!important;height:52px!important;object-fit:cover!important;' +
      'border-radius:4px!important;cursor:pointer!important;opacity:0.45!important;' +
      'border:2px solid transparent!important;box-sizing:border-box!important;' +
      'transition:opacity .15s,border-color .15s!important;flex-shrink:0!important;}' +
    '.mm-lb-th.on{opacity:1!important;border-color:#e67e22!important;}' +
    '.mm-lb-th:hover{opacity:0.75!important;}';

  document.head.appendChild(style);

  // ââ SVG arrows âââââââââââââââââââââââââââââââââââââââââââââââââââââââââââââââ
  var svgL = '<svg width="9" height="15" viewBox="0 0 9 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8 1L1.5 7.5L8 14" stroke="#444" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var svgR = '<svg width="9" height="15" viewBox="0 0 9 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1L7.5 7.5L1 14" stroke="#444" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  // ââ HTML âââââââââââââââââââââââââââââââââââââââââââââââââââââââââââââââââââââ
  var div = document.createElement('div');
  div.id = 'mm-lb';
  div.innerHTML =
    '<div class="mm-lb-modal">' +
      '<button class="mm-lb-x" aria-label="Chiudi">&#10005;</button>' +
      '<div class="mm-lb-stage">' +
        '<img class="mm-lb-img" id="mm-lb-img" src="" alt="">' +
        '<button class="mm-lb-arr" id="mm-lb-prev" aria-label="Precedente">' + svgL + '</button>' +
        '<button class="mm-lb-arr" id="mm-lb-next" aria-label="Successiva">' + svgR + '</button>' +
        '<div class="mm-lb-info"><span id="mm-lb-cur">1</span>/<span id="mm-lb-tot">1</span></div>' +
        '<div class="mm-lb-zoom">' +
          '<button class="mm-lb-zb" id="mm-lb-zo" aria-label="Zoom out">&#8722;</button>' +
          '<button class="mm-lb-zb" id="mm-lb-zi" aria-label="Zoom in">&#43;</button>' +
        '</div>' +
      '</div>' +
      '<div class="mm-lb-thumbs" id="mm-lb-thumbs"></div>' +
    '</div>';
  document.body.appendChild(div);

  var modal    = div;
  var imgEl    = document.getElementById('mm-lb-img');
  var thumbsEl = document.getElementById('mm-lb-thumbs');
  var curEl    = document.getElementById('mm-lb-cur');
  var totEl    = document.getElementById('mm-lb-tot');
  var prevBtn  = document.getElementById('mm-lb-prev');
  var nextBtn  = document.getElementById('mm-lb-next');
  var ziBtn    = document.getElementById('mm-lb-zi');
  var zoBtn    = document.getElementById('mm-lb-zo');

  var imgs = []; var idx = 0;
  var zm = 1, px = 0, py = 0;       // button-zoom state (scale + translate)
  var cz = false;                    // click-zoom active
  var dr = false, dsx = 0, dsy = 0; // drag state

  // ââ Helpers ââââââââââââââââââââââââââââââââââââââââââââââââââââââââââââââââââ
  function fullSrc(src) {
    var clean = src.replace(/\?[^?]*$/, '');
    return clean.replace(/_(pico|icon|thumb|small|compact|medium|large|grande|1024x1024|master|\d+x\d*|\d*x\d+)\./, '_1946x.');
  }

  function collect() {
    imgs = []; var seen = {};
    document.querySelectorAll('.product__media-item').forEach(function(li) {
      var im = li.querySelector('img[src]'); if (!im) return;
      var key = im.src.replace(/\?[^?]*$/, '').replace(/_(pico|icon|thumb|small|compact|medium|large|grande|1024x1024|master|\d+x\d*|\d*x\d+)\./, '_X.');
      if (seen[key]) return; seen[key] = true;
      imgs.push({ full: fullSrc(im.src), thumb: im.src, alt: im.alt || '' });
    });
  }

  // setCursor usa setProperty con 'important' â batte qualsiasi regola CSS
  function setCursor(c) {
    imgEl.style.setProperty('cursor', c, 'important');
  }

  function resetZoom() {
    zm = 1; px = 0; py = 0; cz = false;
    imgEl.style.transform = '';
    imgEl.style.transformOrigin = 'center center';
    setCursor('zoom-in');
  }

  function applyButtonZoom() {
    imgEl.style.transformOrigin = 'center center';
    imgEl.style.transform = zm > 1
      ? 'translate(' + px + 'px,' + py + 'px) scale(' + zm + ')'
      : '';
    setCursor(zm > 1 ? 'grab' : 'zoom-in');
  }

  function show(i) {
    idx = (i + imgs.length) % imgs.length;
    resetZoom();
    imgEl.classList.add('loading');
    var n = new Image();
    n.onload  = function() { imgEl.src = n.src; imgEl.classList.remove('loading'); };
    n.onerror = function() { imgEl.src = imgs[idx].thumb; imgEl.classList.remove('loading'); };
    n.src = imgs[idx].full;
    imgEl.alt = imgs[idx].alt;
    curEl.textContent = idx + 1;
    totEl.textContent = imgs.length;
    thumbsEl.querySelectorAll('.mm-lb-th').forEach(function(t, j) {
      t.classList.toggle('on', j === idx);
      if (j === idx) t.scrollIntoView({ inline: 'nearest', block: 'nearest' });
    });
  }

  function open(i) {
    collect();
    thumbsEl.innerHTML = '';
    imgs.forEach(function(im, j) {
      var t = document.createElement('img');
      t.src = im.thumb; t.className = 'mm-lb-th'; t.alt = im.alt;
      t.addEventListener('click', function() { show(j); });
      thumbsEl.appendChild(t);
    });
    show(typeof i === 'number' ? i : 0);
    modal.classList.add('open');
    document.body.style.overflow = 'hidden';
  }
  window._mmLbOpen = open;

  function close() {
    resetZoom();
    modal.classList.remove('open');
    document.body.style.overflow = '';
  }

  // ââ Button zoom (+/-) ââââââââââââââââââââââââââââââââââââââââââââââââââââââââ
  ziBtn.addEventListener('click', function(e) {
    e.stopPropagation();
    if (cz) resetZoom();            // esci dal click-zoom prima
    zm = Math.min(4, zm + 0.5);
    applyButtonZoom();
  });
  zoBtn.addEventListener('click', function(e) {
    e.stopPropagation();
    zm = Math.max(1, zm - 0.5);
    if (zm <= 1) { px = 0; py = 0; }
    applyButtonZoom();
  });

  // ââ Drag quando button-zoomed ââââââââââââââââââââââââââââââââââââââââââââââââ
  imgEl.addEventListener('mousedown', function(e) {
    if (zm <= 1 || cz) return;
    dr = true;
    dsx = e.clientX - px;
    dsy = e.clientY - py;
    setCursor('grabbing');
    e.preventDefault();
  });
  document.addEventListener('mousemove', function(e) {
    if (!dr) return;
    px = e.clientX - dsx;
    py = e.clientY - dsy;
    applyButtonZoom();
  });
  document.addEventListener('mouseup', function() {
    if (!dr) return;
    dr = false;
    setCursor(zm > 1 ? 'grab' : 'zoom-in');
  });

  // ââ Click-to-zoom (zoom preciso nel punto cliccato) ââââââââââââââââââââââââââ
  imgEl.addEventListener('click', function(e) {
    if (zm > 1) return;   // button-zoom attivo: non interferire
    if (dr)  return;
    e.stopPropagation();

    if (cz) {
      // secondo click â torna alla dimensione originale
      cz = false;
      imgEl.style.transform = '';
      imgEl.style.transformOrigin = 'center center';
      setCursor('zoom-in');
    } else {
      // primo click â zoom 2.5x centrato sul punto cliccato
      cz = true;
      var r  = imgEl.getBoundingClientRect();
      var ox = Math.max(0, Math.min(1, (e.clientX - r.left) / r.width));
      var oy = Math.max(0, Math.min(1, (e.clientY - r.top)  / r.height));
      imgEl.style.transformOrigin = (ox * 100) + '% ' + (oy * 100) + '%';
      imgEl.style.transform = 'scale(2.5)';
      setCursor('zoom-out');   // lente con il meno
    }
  });

  // ââ Nav + tastiera âââââââââââââââââââââââââââââââââââââââââââââââââââââââââââ
  modal.querySelector('.mm-lb-x').addEventListener('click', close);
  modal.addEventListener('click', function(e) { if (e.target === modal) close(); });
  prevBtn.addEventListener('click', function(e) { e.stopPropagation(); show(idx - 1); });
  nextBtn.addEventListener('click', function(e) { e.stopPropagation(); show(idx + 1); });

  document.addEventListener('keydown', function(e) {
    if (!modal.classList.contains('open')) return;
    if (e.key === 'Escape')     close();
    if (e.key === 'ArrowLeft')  show(idx - 1);
    if (e.key === 'ArrowRight') show(idx + 1);
  });

  // ââ Touch swipe ââââââââââââââââââââââââââââââââââââââââââââââââââââââââââââââ
  var tx = 0;
  var stage = modal.querySelector('.mm-lb-stage');
  stage.addEventListener('touchstart', function(e) { tx = e.touches[0].clientX; }, { passive: true });
  stage.addEventListener('touchend',   function(e) {
    var dx = e.changedTouches[0].clientX - tx;
    if (Math.abs(dx) > 50) { dx < 0 ? show(idx + 1) : show(idx - 1); }
  }, { passive: true });

  // ââ Intercept Shopify product-modal âââââââââââââââââââââââââââââââââââââââââ
  function attach() {
    document.querySelectorAll('.product__media-item').forEach(function(li, i) {
      if (li.dataset.mmLb) return;
      li.dataset.mmLb = '1';
      li.style.cursor = 'zoom-in';
      li.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        open(i);
      }, true);
    });
  }

  function patchProductModal() {
    var P = customElements.get('product-modal');
    if (P && !P._mmPatched) {
      P._mmPatched = true;
      P.prototype.show = function() {
        var all = Array.from(document.querySelectorAll('.product__media-item'));
        var li  = this.closest ? this.closest('.product__media-item') : null;
        var i   = li ? all.indexOf(li) : 0;
        open(i >= 0 ? i : 0);
      };
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { attach(); patchProductModal(); });
  } else {
    attach();
    patchProductModal();
  }
  setTimeout(function() { attach(); patchProductModal(); }, 800);
})();
